import React from 'react';
import styled from 'styled-components';
import { Nav, useBreakpoint, spacing } from '@landr/maestro';
import { Trans } from '@lingui/macro';

const StyledNav = styled(Nav)`
    ${({ theme }): string => theme.breakpoint('lg')`
        margin-top: ${spacing('xl')};
        margin-bottom: ${spacing('xl')};
    `}
`;

export const FooterNavigation: React.FC = () => {
    const isVertical = useBreakpoint('lg');
    const horizontalPadding = isVertical ? 'none' : undefined;

    return (
        <StyledNav
            isVertical={isVertical}
            sx={{ justifyContent: 'center', width: 'auto' }}
        >
            <Nav.Item>
                <Nav.Link
                    href="https://www.landr.com/samples"
                    target="_blank"
                    px={horizontalPadding}
                >
                    <Trans>About</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    as="a"
                    href="https://blog.landr.com/"
                    target="_blank"
                    px={horizontalPadding}
                >
                    <Trans>Blog</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    as="a"
                    href="https://support.landr.com"
                    target="_blank"
                    px={horizontalPadding}
                >
                    <Trans>Help</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    as="a"
                    href="https://landr.com/careers"
                    target="_blank"
                    px={horizontalPadding}
                >
                    <Trans>Careers</Trans>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link
                    as="a"
                    href="https://landr.com/en/pricing-terms"
                    target="_blank"
                    px={horizontalPadding}
                >
                    <Trans>Legal</Trans>
                </Nav.Link>
            </Nav.Item>
        </StyledNav>
    );
};
